/* eslint-disable max-len */
import {
    AuthenticatedUser,
    CandidateIcon,
    Feature,
    getUserFromStorage,
    HomeIcon,
    JobIcon,
    ResearchIcon,
} from "@relode/core";
import * as domain from "@relode/core/domain";
import { JobCandidateStatus, JobStatusEnum } from "@relode/core/domain";
import qs from "qs";
import * as React from "react";

import { CandidatesFeature } from "../candidates/candidatesFeature";
import { ClientDashboardContainer } from "../dashboard/clientDashboardContainer";
import { JobsFeature } from "../jobs/jobsFeature";
import { ClientMarketResearchFeature } from "../marketResearch/clientMarketResearchFeature";

export const isUserAllowed = (feature: Feature) => {
    if (!!feature) {
        const user: AuthenticatedUser | null = getUserFromStorage();
        return user && feature.allowedRoles.some(f => f === user.role);
    }
    return false;
};

const initialCandidateSearchQueryParams = qs.stringify(
    {
        jobStatusIds: [JobStatusEnum.OPEN.id, JobStatusEnum.PAUSED.id],
        jobStatusNames: [
            JobStatusEnum.OPEN.description,
            JobStatusEnum.PAUSED.description,
        ],
        jobCandidateStatusIds: [
            JobCandidateStatus.Offered.id,
            JobCandidateStatus.Interviewing.id,
            JobCandidateStatus.Submitted.id,
        ],
        jobCandidateStatusNames: [
            JobCandidateStatus.Offered.description,
            JobCandidateStatus.Interviewing.description,
            JobCandidateStatus.Submitted.description,
        ],
    },
    {
        skipNulls: true,
        sort: (a, b) => a.localeCompare(b),
    }
);

const initialJobSearchQueryParams = qs.stringify(
    {
        jobStatusIds: [JobStatusEnum.OPEN.id, JobStatusEnum.PAUSED.id],
        jobStatusNames: [
            JobStatusEnum.OPEN.description,
            JobStatusEnum.PAUSED.description,
        ],
    },
    {
        skipNulls: true,
        sort: (a, b) => a.localeCompare(b),
    }
);

export const features: Feature[] = [
    {
        name: "dashboard",
        route: "/dashboard",
        component: ClientDashboardContainer,
        tooltip: "review next actions and plan your work",
        icon: <HomeIcon />,
        allowedRoles: [domain.UserRole.ClientAdmin, domain.UserRole.Client],
    },
    {
        name: "research",
        route: "/market-research",
        component: ClientMarketResearchFeature,
        tooltip: "market research",
        icon: <ResearchIcon />,
        allowedRoles: [domain.UserRole.ClientAdmin],
    },    
    {
        name: "jobs",
        route: "/jobs",
        clickRoute: `/jobs?${initialJobSearchQueryParams}`,
        component: JobsFeature,
        tooltip: "jobs",
        icon: <JobIcon />,
        allowedRoles: [domain.UserRole.ClientAdmin, domain.UserRole.Client],
    },
    {
        name: "candidates",
        route: "/candidates",
        clickRoute: `/candidates?${initialCandidateSearchQueryParams}`,
        component: CandidatesFeature,
        tooltip: "job candidates",
        icon: <CandidateIcon />,
        allowedRoles: [domain.UserRole.ClientAdmin, domain.UserRole.Client],
    },
];
